var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchField',{attrs:{"limitWidth":_vm.limitWidth},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})}
var staticRenderFns = []

export { render, staticRenderFns }